export default "__VITE_ASSET__DkAx5Rlw__"